































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import CommonModalHeader from '@/components/common/CommonModalHeader.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import { vxm } from '@/store';

@Component({
  components: {
    CommonModalHeader,
    CommonButton,
  },
})
export default class AddFileModal extends Vue {
  @Prop(Boolean) public isAddFileModal!: boolean;
  private modalHeaderTitle: 'ファイルを追加します' = 'ファイルを追加します';
  private modalMode: string = 'add';
  private items: Array<'要件定義' | '画面設計書' | '画面フロー'> = ['要件定義', '画面設計書', '画面フロー'];
  private uploadIcon: string = require('../../../assets/upload2.png');
  private isDropAble: boolean = false;
  /** 追加するファイルを格納する */
  private files: (string | Blob)[] = [];
  /** ファイルが有効なドロップ対象の上をドラッグされている時 */
  private dragOver(): void {
    this.isDropAble = true;
  }
  /** ファイルがドラッグされて、有効なドロップ対象からはずれた時 */
  private dragLeave(): void {
    this.isDropAble = false;
  }
  /** ファイルをドロップしたときfailsに格納する */
  private dropFile(event: DragEvent): void {
    if (event.dataTransfer === null) {
      return;
    } else {
      this.files.push(event.dataTransfer.files[0]);
      this.isDropAble = false;
    }
  }
  /** filsに格納したファイルを削除する */
  private deleteFile(): void {
    this.files.splice(0);
  }

  private modalCloseButtonColor(): string | undefined {
    if (this.modalMode === 'delete') {
      return '#fa5f7e';
    } else if (this.modalMode === 'add') {
      return '#4384f3';
    } else if (this.modalMode === 'move') {
      return 'green';
    }
  }

  // ファイル選択ボタン発火
  private openExplorer(): void {
    const input: HTMLElement = this.$refs.input as HTMLElement;
    input.click();
  }

  /** エクスプローラーで選択したファイルを格納 */
  private getFileContent(files: (string | Blob)[] | undefined): void {
    if (!files) {
      return;
    }
    files.forEach((file) => {
      this.files.push(file);
    });
    // https://github.com/microsoft/TypeScript/issues/31816#issuecomment-646259502
  }

  private async uploadFile() {
    const formData = new FormData();
    this.files.forEach((file) => {
      formData.append('storageFiles', file);
    });
    formData.append('accountId', vxm.theoryApi.authStore.getCurrentUserInfo?.results.accountId.toString()!);
    formData.append('directoryId', `${this.currentDirectoryId}`);
    const param = {
      'project-id': this.projectId!,
    };
    await vxm.theoryApi.filesStore.createFile({ query: param, param: formData });
    await Promise.all([
      vxm.theoryApi.directoriesStore.fetchDirectoriesAndFiles({
        'project-id': this.projectId!,
        'sort': 'name',
        'order': 'asc',
      }),
    ]);
    this.closeAddFileModal();
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId;
  }

  private get currentDirectoryId() {
    const response = vxm.theoryApi.directoriesStore.getCurrentDirectory;
    if (response) {
      return response.directoryId;
    } else return null;
  }

  @Emit('closeAddFileModal')
  private closeAddFileModal(): void {
    return;
  }
}
